//FridgeMagnet is a quiz type that presents the user with a EMI sentence and expects the English translation of that word. User can build up the translation by selecting words one by one from a set of possible translated words
<template>
  <v-container>
    <v-layout column justify-space-around align-space-around>
      <v-flex class="prompt-container">
        <h2 v-bind:class="promptSize">{{prompt.emiSentence}}</h2>
      </v-flex>

      <!-- User selected answers -->
      <v-layout row justify-start v-show="!typeAnswer" class="selected-answers ma-3">
        <v-btn
          v-for="(choice,index) in userAnswerArr"
          :key="index"
          @click="removeWord(choice, index)"
        >{{choice}}</v-btn>
      </v-layout>

      <!-- Input Container -->
      <v-flex class="input-container ma-3">
        <v-layout wrap justify-start fluid v-show="!typeAnswer">
          <v-flex :class="computedMargin" xs1 v-for="(choice, index) in choices" :key="index">
            <v-btn v-show="choiceStatus[index] < 1" @click="addWord(choice,index)">{{choice}}</v-btn>
          </v-flex>
        </v-layout>

        <v-form v-show="typeAnswer">
          <v-text-field v-model="userAnswerStr"></v-text-field>
        </v-form>
      </v-flex>

      <v-flex v-if="answered">
        <v-card flat width="80%">
          <v-container fill-height fluid>
            <v-card-text>
              <p class="green--text" style="font-size: 300%" v-if="correct">
                Correct!
              </p>
              <p class="red--text" style="font-size: 300%" v-else>
                Incorrect!
              </p>
              <p class="secondary--text" style="font-size: 150%">Correct Answer: {{this.prompt.sentenceTranslation}} </p>
            </v-card-text>
          </v-container>
        </v-card>
      </v-flex>    

      <v-layout column justify-center align-center v-if="!answered">
        <v-flex class="switch-input">
          <v-btn @click="toggleTypeAnswer">
            {{switchInputText }}
            <v-icon right>keyboard</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-btn @click="handleAnswer" v-if="!answered" :disabled="userAnswerStr.length <= 0" block>Check</v-btn>
        <v-btn @click="handleSubmit" v-else>Next</v-btn>
        <v-btn @click="handleSkip" v-if="!answered"> Skip </v-btn>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: "FridgeMagnet",
  props: {
    prompt: Object
  },
  data() {
    return {
      userAnswerArr: [],
      userAnswerStr: "",
      selectedChoices: [],
      correct: false,
      answered: false,
      // answerChoices: this.fmQuestion.sentenceTranslation
      //   .split(/\s+/)
      //   .concat(this.fmQuestion.extraWords.map(word => word.extraWord)),
      // numberOfChoices:
      //   this.fmQuestion.sentenceTranslation.split(/\s+/).length +
      //   this.fmQuestion.extraWords.length,
      choiceStatus: [],
      typeAnswer: false
    };
  },
  created() {
    this.choiceStatus = Array(
        this.choices.length
      ).fill(0)
  },
  methods: {
    addWord: function(choice, index) {
      this.userAnswerArr.push(choice);
      this.selectedChoices.push(choice);
      this.userAnswerStr = this.getAnswerStr();
      this.choiceStatus[index] = 1;
    },
    removeWord: function(choice, index) {
      console.log(index);
      this.choiceStatus[this.choices.indexOf(choice)] = 0;
      this.selectedChoices.splice(index, 1);
      this.userAnswerArr.splice(index, 1);
      this.userAnswerStr = this.getAnswerStr();
    },
    handleSubmit: function() {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    handleAnswer: function() {
      this.answered = true;
      this.correct =
        this.userAnswerStr.toLowerCase() == this.prompt.sentenceTranslation.toLowerCase();
      if(!this.correct){
        for(var j = 0; j < this.prompt.sentenceTranslations.length; j++){
          if(this.prompt.sentenceTranslations[j].sentenceTranslationChoice == this.userAnswerStr.toLowerCase()){
            this.correct = true;
            break;
          }else{
            this.correct = false;
          }
        }
      }
        this.$emit("check", { correct: this.correct });
    },
    handleSkip: function(){
      this.clear();
    },
    clear: function() {
      this.$emit("next");
      this.answered = false;
      this.userAnswerArr = [];
      this.selectedChoices = [];
      this.choiceStatus = Array(
        this.choices.length
      ).fill(0);
    },
    toggleTypeAnswer: function() {
      this.typeAnswer = !this.typeAnswer;
    },
    getAnswerStr: function() {
      var result = "";
      for (var i = 0; i < this.userAnswerArr.length; i++) {
        result += this.userAnswerArr[i] + " ";
      }
      return result.substr(0, result.length - 1);
    }
  },
  computed: {
    answerSentence: function() {
      var result = "";
      for (var i = 0; i < this.userAnswerArr.length; i++) {
        result += this.userAnswerArr[i] + " ";
      }

      return result.substr(0, result.length - 1);
    },
    choices: function() {
      return _.shuffle(
        this.prompt.sentenceTranslation
          .split(/\s+/)
          .concat(this.prompt.extraWords.map(word => word.extraWord))
      );
    },
    switchInputText: function() {
      return this.typeAnswer ? "Magnets " : "Type ";
    },
    promptSize: function(){
      switch (this.$vuetify.breakpoint.name){
        case 'xs' : return 'display-3 font-weight-thin font-italic'
        break;
        default : return 'display-4 font-weight-thin font-italic'
      }
    },
    computedMargin: function(){
      switch (this.$vuetify.breakpoint.name){
        case 'xs' : return 'mx-5'
        break;
        case 'sm' : return 'mx-5'
        break;
        case 'md' : return 'mx-5'
        break;
        default : return 'mx-1'
      }
    },
  }
};
</script>

<style scoped>
</style>
